export default __webpack_public_path__ + "static/Calibre-MediumItalic-7aa140573fd9ed30ae01e117c418b12b.woff2";